import React from 'react';
import { InspectionTemplate } from '../../services/inspectionsApi';
import InspectionForm from './InspectionForm';
import { btnSmall } from './common';
import { ui } from '../../styles/shared';
import { fmtDate } from '../../utils/format';

/**
 * Förhandsvisning av en planerad kontroll från årshjulet: vad som ska kontrolleras,
 * bara att läsa. Kontrollen finns inte ännu; den skapas av schemaläggaren några dagar
 * innan, eller med "Gör i förtid" under Att göra.
 */
export interface PlannedInfo {
    name: string;
    date: string;
    zone_name: string | null;
    template_id: number | null;
    template_name: string;
}

interface Props {
    planned: PlannedInfo;
    templates: InspectionTemplate[];
    onClose: () => void;
}

const PlannedPanel: React.FC<Props> = ({ planned, templates, onClose }) => {
    const template = templates.find(t => t.id === planned.template_id) ?? null;
    return (
        <div style={{ ...ui.card, borderColor: '#0f3460', borderStyle: 'dashed', padding: 20 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 10, flexWrap: 'wrap' }}>
                <div>
                    <h2 style={{ margin: '0 0 4px' }}>{planned.name}</h2>
                    <div style={{ fontSize: 13, color: '#666' }}>
                        {planned.template_name}{planned.zone_name ? ` · ${planned.zone_name}` : ''} · planerad till {fmtDate(planned.date)}
                        {' '}<span style={ui.badge('#0f3460')}>Planerad</span>
                    </div>
                </div>
                <button onClick={onClose} style={btnSmall('#6c757d')}>Stäng</button>
            </div>
            <div style={{ background: '#e8f0fe', color: '#1a4aa6', borderRadius: 8, padding: 10, margin: '12px 0', fontSize: 13 }}>
                Så här ser kontrollen ut. Den skapas automatiskt några dagar innan den ska göras, eller med "Gör i förtid" under Att göra.
            </div>
            {template ? (
                <InspectionForm fields={template.fields} answers={{}} readOnly />
            ) : (
                <div style={{ color: '#888', fontSize: 13 }}>Mallen hittades inte.</div>
            )}
        </div>
    );
};

export default PlannedPanel;
